const KEY = "drnova_consent";
const EVT = "drnova:consent";

export const getConsent = () => JSON.parse(localStorage.getItem(KEY) || "null");
export const setConsent = (ads) => {
  localStorage.setItem(KEY, JSON.stringify({ necessary: true, ads, date: new Date().toISOString() }));
  window.dispatchEvent(new Event(EVT));
};
export const openConsentPrefs = () => window.dispatchEvent(new Event("drnova:consent-open"));
export const onConsent = (fn) => { window.addEventListener(EVT, fn); return () => window.removeEventListener(EVT, fn); };
